export interface CommonConfigOptions {
  defaultEdition: number;
  appVersion: string;
  auditorAccessPrivilege: string;
  auditorAccessPrivilege2025: string;
}

const CommonConfig: CommonConfigOptions = {
  defaultEdition: 2022, // CSC - Remove me...
  appVersion: '4.2.0', // CSC - Not sure why this is here, but it needs to come out
  auditorAccessPrivilege: 'idtt-22-application.auditor-access.org',
  auditorAccessPrivilege2025: 'idtt-25-application.auditor-access.org'
};

export default CommonConfig;
